import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Response {
  enrolled_in_health_plans_count?: number | null;
}
const QUERY_KEY = 'HEALTH_PLAN_ENROLLMENTS_BRIEF';
const useHealthPlanEnrollmentsBriefQuery = () => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY],
    // TODO: the type is missing
    () => api.get<Response>(API_URL.REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BRIEF),
    {
      cacheTime: 0,
    }
  );
  const formattedData = useMemo(() => {
    const response = data?.data;
    const enrolledPlans = response?.enrolled_in_health_plans_count;

    return {
      enrolledPlans: !!enrolledPlans || enrolledPlans === 0 ? `${enrolledPlans}` : null,
    };
  }, [data?.data]);
  return {
    isLoading,
    data: formattedData,
  };
};

export default useHealthPlanEnrollmentsBriefQuery;
